import axios from 'axios';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

export default class ServiceRankingService {
  /**
   * Obtiene el ranking de servicios por reembolsos aprobados (12m) para los países dados.
   * @param {string[]} isos - ISO de países a incluir (ej. ['CL'] o ['CL','PE']).
   * @returns {Promise<{status: string, data?: object}>}
   */
  static async getServiceRanking(isos = []) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const params = new URLSearchParams();
      isos.forEach(iso => params.append('iso', iso));

      const response = await axios.get(`${adminUrl}/service-ranking?${params.toString()}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });

      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error' };
    } catch (error) {
      return { status: 'error' };
    }
  }
}
